import React, { ReactNode } from "react";
import Card from "../../components/Card/Card";
import Divider from "../../components/Divider/Divider";
import Link from "../../components/Link/Link";
import Text from "../Text/Text";
import { SanityThirdPartyResources } from "../../model/common";
import { imageUrlBuilder } from "../../utils/images";
import styles from "./ThirdPartyResources.module.scss";

const ThirdPartyResources = ({ title, resources }: ThirdPartyResourcesProps) =>
  resources && resources.length > 0 ? (
    <div className={styles.container}>
      <Text variant="h4">{title}</Text>
      <Card className={styles.card}>
        <ul className={styles.list}>
          {resources.map((r: SanityThirdPartyResources, index: number) => (
            <React.Fragment key={r._id}>
              <li className={styles.listItem}>
                {/*Intentionally no alt for better experience as it'd be the same organisation name*/}
                <img
                  width={20}
                  height={20}
                  src={
                    imageUrlBuilder
                      .image(r.image)
                      .height(40)
                      .width(40)
                      .fit("fillmax")
                      .bg("fff")
                      .ignoreImageParams()
                      .url()!
                  }
                  alt=""
                  className={styles.image}
                />
                <Text variant="default">
                  <Link to={r.url} className={styles.link}>
                    {r.title}
                  </Link>
                </Text>
              </li>
              {index + 1 !== resources.length && <Divider />}
            </React.Fragment>
          ))}
        </ul>
      </Card>
    </div>
  ) : null;

export default ThirdPartyResources;

type ThirdPartyResourcesProps = {
  title: ReactNode;
  resources: SanityThirdPartyResources[];
};
